export default [
  {
    path: '/activity/bigCustomerRecharge',
    meta: {
      title: '充值'
    },
    component: () => import('@/pages/activity/bigCustomerRecharge')
  },
  {
    path: '/activity/bigCustomerRecharge/recharge',
    meta: {
      title: '充值'
    },
    component: () => import('@/pages/activity/bigCustomerRecharge/recharge.vue')
  }
]
